import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Protected route component that checks if user is authenticated and has required role
const ProtectedRoute = ({ children, requiredRole, allowedRoles }) => {
  const { currentUser, userRole, checkAccess, checkEmailVerified } = useAuth();
  const location = useLocation();
  
  // If not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ message: 'ログインが必要です。', from: location }} replace />;
  }
  
  // If email not verified, redirect to verification page
  if (!checkEmailVerified()) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }
  
  // Check access based on allowedRoles array or requiredRole
  if (allowedRoles && Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    // If allowedRoles is provided, check if user role is included
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  } else if (requiredRole && !checkAccess(requiredRole)) {
    // Backward compatibility: If doesn't have required role, redirect to unauthorized page
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }
  
  // User is authenticated and authorized
  return children;
};

export default ProtectedRoute; 